import { ComponentEvents } from '../../../../global/interfaces/component.interface';

const EVENT_NAME = 'AtomFabButtonEvents__';

/** The type of custom events emitted */
export type AtomFabButtonEventTypes = {
	buttonClicked: Event | MouseEvent;
};

export const AtomFabButtonEvents: ComponentEvents<AtomFabButtonEventTypes> = {
	/** The custom event emitted when the button is clicked */
	buttonClicked: EVENT_NAME + 'buttonClicked',
};
